import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Ignore the harmless removeChild/insertBefore DOM errors
    // caused by browser extensions or mobile browser features
    const msg = error?.message || '';
    if (
      msg.includes('removeChild') ||
      msg.includes('insertBefore') ||
      msg.includes('not a child')
    ) {
      this.setState({ hasError: false });
      return;
    }
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen ept-bg-ambient flex items-center justify-center p-6">
          <div className="bg-[#1a1f2e] border border-[#2a3142] rounded-xl p-8 text-center max-w-md">
            <h2 className="text-xl font-bold text-white mb-3">Qualcosa è andato storto</h2>
            <p className="text-slate-400 mb-6">Si è verificato un errore inatteso.</p>
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.reload();
              }}
              className="px-6 py-2 bg-[#00F0FF] text-black font-semibold rounded-lg"
            >
              Ricarica pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
